module.exports = __webpack_public_path__ + "img/ic-save-gift.3541ee68.svg";